// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ColumnOrdering-base__dNqFQ{padding:var(--size-2) var(--size-3)}@media only screen and (min-width: 64rem){.ColumnOrdering-base__dNqFQ{padding:0 var(--size-1_5) var(--size-1_5) var(--size-1_5)}}.ColumnOrdering-dropIndicator__HzWOG{position:relative;height:0}.ColumnOrdering-dropIndicator__HzWOG::before{position:absolute;top:0;right:0;left:0;height:var(--size-0_25);background-color:var(--gray-12);content:\"\"}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "ColumnOrdering-base__dNqFQ",
	"dropIndicator": "ColumnOrdering-dropIndicator__HzWOG"
};
export default ___CSS_LOADER_EXPORT___;
